import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';

import { useAccount } from 'reservations/account/providers/AccountProvider';
import { useRestaurantName } from 'reservations/account/providers/ConfigProvider';
import Header from 'reservations/base/components/Header';
import { BOX_SHADOW_NORMAL } from 'reservations/brand/constants';
import { WHITE } from 'reservations/brand/helpers/v1/palette';

const Image = styled('img')({
  position: 'relative',
  height: '100%',
  width: '100%',
  objectFit: 'contain'
});

export const TextAndLogoLayout = () => {
  const restaurantName = useRestaurantName();
  const { logo } = useAccount();

  return (
    <Grid
      data-testid="text-and-logo-layout"
      sx={{
        display: 'flex',
        height: '100%',
        width: '100%',
        alignItems: 'center',
        justifyContent: 'start',
        columnGap: '1rem'
      }}
    >
      <Paper
        data-testid="logo-wrapper"
        sx={{
          overflow: 'hidden',
          borderRadius: '4px',
          boxShadow: BOX_SHADOW_NORMAL,
          width: '180px',
          height: '180px',
          backgroundColor: 'transparent'
        }}
      >
        <Image src={logo.url} alt={logo.alt_text} data-testid="logo-small" />
      </Paper>

      <Header text={restaurantName} color={WHITE} fontSize="42px" />
    </Grid>
  );
};
